import { useCallback } from 'react';
import { useSessionStartChargingMutation } from '../../../services/sessions.api';
import { useSessionStopChargingMutation } from '../../../services/sessions.api';
import { SessionStartPayload } from '../dto/charger.dto';

export const useSessionActions = () => {
  const [
    triggerStartSession,
    { data: startSessionData, isError: isStartSessionError, error: startSessionError },
  ] = useSessionStartChargingMutation();
  const [triggerStopSession, { isError: isStopSessionError, error: stopSessionError }] =
    useSessionStopChargingMutation();

  const startSession = useCallback(
    (payload: SessionStartPayload) => {
      triggerStartSession(payload);
    },
    [triggerStartSession],
  );

  const stopSession = useCallback(
    (sessionId: string) => {
      triggerStopSession(sessionId);
    },
    [triggerStopSession],
  );

  return {
    startSession,
    stopSession,
    startSessionData,
    isStartSessionError,
    startSessionError,
    isStopSessionError,
    stopSessionError,
  };
};
